import { deriveCategory, inboxKey, inboxRef } from './types/notifications';
/** Seen is a browser's acknowledgement of the inbox, independent of reading a row. */
export const inboxSeenStorageKey = (account) => `oq:inbox-seen:${account}`;
export function parseInboxSeen(value) {
    return Array.isArray(value) ? value.filter((key) => typeof key === 'string') : [];
}
export function acknowledgeInboxItems(seen, items) {
    return [...new Set([...seen, ...items.map(item => inboxKey(inboxRef(item)))])];
}
export function unseenInboxCounts(items, seen) {
    const acknowledged = new Set(seen);
    let alerts = 0, activity = 0, announcements = 0;
    for (const feed of items) {
        if (feed.item.isRead || acknowledged.has(inboxKey(inboxRef(feed))))
            continue;
        if (feed.source === 'announcement')
            announcements++;
        else if ((feed.item.category || deriveCategory(feed.item.type)) === 'alert')
            alerts++;
        else
            activity++;
    }
    return { alerts, activity, announcements, total: alerts + activity + announcements };
}
//# sourceMappingURL=inboxAttention.js.map